import { Seo } from "../components/Seo";
import { CallButton, GhostLink, Reveal } from "../components/ui-bits";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Page Not Found | JIF – Jack Iannotti Flowers, Coventry RI"
        description="The page you're looking for has wandered off. Call (401) 822-4440 or head back to the JIF Flowers homepage."
      />
      <section className="mx-auto flex min-h-[80vh] max-w-3xl flex-col items-center justify-center px-5 pt-32 text-center sm:px-8">
        <Reveal>
          <p className="font-serif text-7xl font-medium text-gold sm:text-8xl">404</p>
          <h1 className="mt-6 font-serif text-3xl font-medium text-plum sm:text-4xl">
            This page has wandered out of the cooler
          </h1>
          <p className="mx-auto mt-5 max-w-md text-[17px] leading-relaxed text-charcoal/80">
            The page you're looking for isn't here — but the flowers are. Head home, or call the shop and we'll help
            you find what you need.
          </p>
          <div className="mt-9 flex flex-wrap items-center justify-center gap-6">
            <CallButton testid="notfound-call-button" />
            <GhostLink href="/" testid="notfound-home-link">
              Back to Home
            </GhostLink>
          </div>
        </Reveal>
      </section>
    </>
  );
}
